// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useFlagsmith } from 'flagsmith/react';
import { useDispatch } from 'react-redux';
import { toggleChangelog } from '../../../store/modules/changelog/actions';
import packageJson from '../../../../package.json';

function Changelog() {
  const dispatch = useDispatch();
  const flagsmith = useFlagsmith().getAllFlags();
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const flagsArray = Object.keys(flagsmith).map((flagName) => {
      const flagData = flagsmith[flagName];
      return {
        name: flagName,
        id: flagData.id,
        enabled: flagData.enabled,
        value: flagData.value,
      };
    });

    setFlags(flagsArray);
    setLoading(false);

    setLoading(false);
  }, [flagsmith]);

  function closeModal() {
    dispatch(toggleChangelog());
  }

  return (
    !loading && (
      <div className="changelog-modal">
        <div className="changelog-modal-close" onClick={() => closeModal()}>
          x
        </div>
        <div className="changelog-modal-title">
          🚀 Changelog da versão {packageJson?.version} 🚀
        </div>
        <div className="changelog-modal-content">
          <div className="changelog-header">
            <div className="changelog-card-column">Status</div>
            <div className="changelog-card-column">Nome da flag</div>
            <div className="changelog-card-column">valor</div>
          </div>
          {flags?.map((flag) => (
            <div className="changelog-card" key={flag.id}>
              <div className="changelog-card-column">
                {flag.enabled ? '🟢' : '🔴'}
              </div>
              <div className="changelog-card-column">{flag.name}</div>

              <div
                className="changelog-card-column"
                onClick={() => console.log(flag.value)}
              >
                {flag.value ? (
                  <span className="flag-value">{flag.value}</span>
                ) : (
                  <span className="no-value">-</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
}

export default Changelog;
